import { useSdk } from '~/sdk';

export const useCategory = (slug:string, page:number, sort:any) => {
  const getCategoryData = async (slug:string, page:number, sort:any) => {
    return await useSdk().magento.category(slug, page, sort);
  };
  const getProductsWithFilter = async (page:number, sort:any, filter:any) => {
    return await useSdk().magento.productsFilter(page, sort, filter);
  };
  const getCategoryFacets = async (categoryId:string) => {
    return await useSdk().magento.categoryFacets(categoryId);
  };
  return {
    getCategoryData,
    getCategoryFacets,
    getProductsWithFilter,
  };
};
